const g = typeof global !== 'undefined' ? global : window;

export default function expose(objects) {
  Object.keys(objects).forEach((key) => {
    g[key] = objects[key];
  });
}
